//import { TweenMax, TimelineMax } from 'gsap';
//import ScrollMagic from 'ScrollMagic';
//import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
//ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default {
  init() {
    var $archiveSlider = $('.project-archive__navigation');
    //projects nav slider
    $archiveSlider.slick({
      speed: 1000,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      infinite: true,
      draggable: true,
      arrows: false,
      dots: false,
      variableWidth: true,
      variableHeight: true,
    });

    $archiveSlider.on(
      'beforeChange',
      function (event, slick, currentSlide, nextSlide) {
        $('.single__nav-slide').each(function () {
          $('.single__nav-slide').removeClass('active');
          $('.single__nav-slide').eq(nextSlide).addClass('active');
        });

        $.each(
          $('#archive-content .project-archive__content-container > *'),
          function (indexInArray, valueOfElement) {
            $(valueOfElement).animate(
              { opacity: 0 },
              500 * (indexInArray + 0.25)
            );
          }
        );
      }
    );

    $archiveSlider.on('afterChange', function () {
      var $href = $('.slick-current').attr('href');
      $('#archive-content').html('').css({ opacity: 0 });
      $('#archive-content').load(
        $href + ' #archive-content .project-archive__content-container',
        function () {
          setTimeout(() => {
            $('#archive-content').animate({ opacity: 1 }, 250);
          }, 125);
        }
      );
    });

    var slug = $('.project-archive-container').data('archive-slug');
    var $slide = $('.single__nav-slide.slick-active.' + slug).data(
      'slick-index'
    );
    console.log('slug:', slug, 'slide: ', $slide);
    
    
    $archiveSlider.slick('slickGoTo', $slide);

    //Projects archive navigation line
    var $svgProjNavLine = $('.slider-nav-line').drawsvg({
      duration: 2000,
      stagger: 700,
      reverse: false,
    });

    $svgProjNavLine.drawsvg('animate');

    $('.single__nav-slide').on('click', function (event) {
      event.preventDefault();
      var slide_active = $(this).data('slick-index');

      $archiveSlider.slick('slickGoTo', slide_active);
      let currentPath = $(this).children().text();
      $('body #p-title, body #d-title, body #b-title').text(currentPath)
      $('body #nf-field-50').val(currentPath)

      console.log('active:', $(this).children().text());
    });

    $(document).on('click', '.video-link', function (event) {
      event.preventDefault();
      $('.venobox').venobox();
    });

    $(document).on('click', '.download-link', function (event) {
      event.preventDefault();
      
      $('.vbox-close').hide();
        $('.part-2').hide();
      $('.venobox_custom').venobox({
        framewidth: '940px', 
        frameheight: 'auto', 
        border: '0', 
        bgcolor: '#f53362', 
        titleattr: 'data-title',
      });
      
      
    });
   
    $(document).on('click', '.get-brochure', function () {
      
      $('#popmake-4939').popmake('close');
      setTimeout(() => {
        location.reload()
      }, 1000);
      
    });
    // $(document).on('click', '.get-brochure', function () {
    //   // event.preventDefault();
    //   $('.vbox-close').trigger('click');
    // });
    $(document).on('click', '.x-close', function () {
      // event.preventDefault();
      $('.vbox-close').trigger('click');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/project-archive.js